import callApi from 'helpers/callApi';

//callApi({ url:
export const getWithdraws = (params) => callApi({ url: '/transactions', query: params });
export const getAllWithdraws = (params) => callApi({ url: '/transactions', query: { ...params, limit: 10000, page: 1 } });
export const getPaymentVouchers = (params) => callApi({ url: '/transactions/payment-vouchers', query: params });
export const getWithdrawById = (id) => callApi({ url: `/transactions/${id}` });

export const paidWithdraw = (id) => callApi({ url: `/transactions/${id}/paid`, method: 'post' });
export const paidWithdraws = (data) => callApi({ url: '/transactions/paid', body: data });

export const rejectWithdraw = (id) => callApi({ url: `/transactions/${id}/reject`, method: 'post' });
export const rejectWithdraws = (data) => callApi({ url: '/transactions/reject', body: data });

export const editWithdrawal = (id, data) => callApi({ url: `/transactions/${id}`, body: data, method: 'put' });
